import { render, staticRenderFns } from "./liste-assures.html?vue&type=template&id=4db15c71&scoped=true&external"
import script from "./liste-assures.js?vue&type=script&lang=js&external"
export * from "./liste-assures.js?vue&type=script&lang=js&external"
import style0 from "./liste-assures.scss?vue&type=style&index=0&id=4db15c71&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db15c71",
  null
  
)

export default component.exports